export function scrollToTop(): void {
  document.documentElement.scrollTop = 0
  window.parent.postMessage('scroll to top', '*')
}
